import { modularScale } from 'polished';

export default (steps) => modularScale(steps, '1em', 'minorThird');
